import {Component} from '@angular/core';
import {AppDialogComponent} from "../../common/app-dialog/app-dialog.component";
import {
    FormActionButtonsComponent
} from "../../common/forms/form-action-buttons/form-action-btns.component";
import {
    FormButtonComponent
} from "../../common/forms/form-button/form-button.component";
import {
    FormItemTextComponent
} from "../../common/forms/form-item-text/form-item-text.component";
import {AppAlertService} from "../../core";

@Component({
    selector: 'confirm-dialog',
    standalone: true,
    imports: [
        AppDialogComponent,
        FormActionButtonsComponent,
        FormButtonComponent,
        FormItemTextComponent
    ],
    templateUrl: './confirm-dialog.component.html',
    styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
    constructor(public appAlert: AppAlertService) {
    }
}
